import { render, staticRenderFns } from "./tasksMakeMoney.vue?vue&type=template&id=05396d42&scoped=true&"
import script from "./tasksMakeMoney.vue?vue&type=script&lang=js&"
export * from "./tasksMakeMoney.vue?vue&type=script&lang=js&"
import style0 from "./tasksMakeMoney.vue?vue&type=style&index=0&id=05396d42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05396d42",
  null
  
)

export default component.exports